import React from 'react'
import PropTypes from 'prop-types'
import { ICON_NAMES } from '../../../constants'
import FlexColumn from '../FlexColumn'
import Icon from '../../atoms/Icon'

const mapDefaults = (activityType, message, icon, iconSize) => {
  switch (activityType?.toLowerCase()) {
    case 'activity':
      return {
        message: message || 'No Activities Available',
        icon: icon || ICON_NAMES.milestone,
        iconSize: iconSize || 20
      }
    case 'task':
      return {
        message: message || 'No Tasks Available',
        icon: icon || ICON_NAMES.task,
        iconSize: iconSize || 20
      }
    case 'meeting':
      return {
        message: message || 'No Meetings Available',
        icon: icon || ICON_NAMES.calendar,
        iconSize: iconSize || 20
      }
    default:
      return {
        message: message || 'No Items Available',
        icon: icon || ICON_NAMES.warning,
        iconSize: iconSize || 20
      }
  }
}

function EmptyType ({ activityType, message, icon, iconSize, className, style }) {
  const values = mapDefaults(activityType, message, icon, iconSize)

  return (
    <FlexColumn className={className} style={style}>
      <Icon name={values.icon} customSize={values.iconSize} />
      <div className='font-size-sm'>{values.message}</div>
    </FlexColumn>
  )
}

EmptyType.propTypes = {
  activityType: PropTypes.string,
  message: PropTypes.string,
  icon: PropTypes.string,
  iconSize: PropTypes.number,
  className: PropTypes.string,
  style: PropTypes.object
}

EmptyType.defaultProps = {
  className: 'justify-center items-center radius-md px-3 py-2 color-disabled',
  style: { color: 'var(--color-neutral-500)', fill: 'var(--color-neutral-500)' }
}

export default EmptyType
